<!--
 * @Author: ext.chenghuan8
 * @Date: 2025-11-28 10:22:34
 * @LastEditors: ext.chenghuan8
 * @LastEditTime: 2025-12-02 11:36:28
 * @Description:
 * @contact_information: ext.chenghuan8@jd.com
-->
<template>
  <div class="card backlog-card" style="background: linear-gradient( 180deg, #FAEFDC 0%, #FBF1E1 10%,#FDF7ED 20%, #FDF9F3 35%,#FFFFFF 50%);">
    <div class="card-header">待办事项</div>
    <Tabs :animated="false" :value="currentTabIndex.toString()" @on-click="handleTabClick">
        <TabPane :label="getTabLabel(todoList[0])" :name="'0'">
          <div class="backlog-list-wrapper">
            <div class="info-column" v-for="(item,index) in workItemList" :key="index">
              <div class="tips">
                <a :href="item.dealPath" target="_blank" @click="handleTimer">{{ item.subject }}</a>
              </div>
              <div class="time">
                {{ item.createTime }} |
                <template v-if="['auth-sap-pi', 'auth-sap-bw'].includes(item.appSign)">{{ $t('homePage.hr') }}</template>
                <template v-else-if="['auth-oa'].includes(item.appSign)">{{ $t('homePage.oa') }}</template>
                <template v-else-if="['auth-crm'].includes(item.appSign)">{{ $t('homePage.crm') }}</template>
                <template v-else-if="['auth-reim'].includes(item.appSign)">{{ $t('homePage.fkxt') }}</template>
                <template v-else-if="['auth-hwcrm'].includes(item.appSign)">{{ $t('homePage.hwcrm') }}</template>
                <template v-else-if="['srm'].includes(item.appSign)">{{ $t('homePage.srm') }}</template>
                | {{ item.applicantName }}
              </div>
            </div>
            <div class="info-column" v-if="workItemList.length === 0">{{ $t('mqzwdbcl') }}</div>
          </div>
        </TabPane>
        <TabPane :label="getTabLabel(todoList[1])" :name="'1'">
          <div class="backlog-list-wrapper">
            <div class="info-column" v-for="(item,index) in getFilteredList('auth-oa')" :key="index">
              <div class="tips">
                <a :href="item.dealPath" target="_blank" @click="handleTimer">{{ item.subject }}</a>
              </div>
              <div class="time">{{ item.createTime }} | {{ $t('homePage.oa') }} | {{ item.applicantName }}</div>
            </div>
            <div class="info-column" v-if="workItemDetail.oanum > 50">
              <div class="workitem-link" @click="itemclickWorkItem(workItemDetail.oaurl, 'oa')">
                待办数量共计{{ workItemDetail.oanum }}条，更多请进入OA系统查看
              </div>
            </div>
            <div class="info-column" v-if="getFilteredList('auth-oa').length === 0">{{ $t('mqzwdbcl') }}</div>
          </div>
        </TabPane>
        <TabPane :label="getTabLabel(todoList[2])" :name="'2'">
          <div class="backlog-list-wrapper">
            <div class="info-column" v-for="(item,index) in getFilteredList('auth-crm')" :key="index">
              <div class="tips">
                <a :href="item.dealPath" target="_blank" @click="handleTimer">{{ item.subject }}</a>
              </div>
              <div class="time">{{ item.createTime }} | {{ $t('homePage.crm') }} | {{ item.applicantName }}</div>
            </div>
            <div class="info-column" v-if="workItemDetail.crmNum > 50">
              <div class="workitem-link" @click="itemclickWorkItem(workItemDetail.crmUrl, 'crm')">
                待办数量共计{{ workItemDetail.crmNum }}条，更多请进入CRM系统查看
              </div>
            </div>
            <div class="info-column" v-if="getFilteredList('auth-crm').length === 0">{{ $t('mqzwdbcl') }}</div>
          </div>
        </TabPane>
        <TabPane :label="getTabLabel(todoList[3])" :name="'3'">
          <div class="backlog-list-wrapper">
            <div class="info-column" v-for="(item,index) in getFilteredList('auth-hwcrm')" :key="index">
              <div class="tips">
                <a :href="item.dealPath" target="_blank" @click="handleTimer">{{ item.subject }}</a>
              </div>
              <div class="time">{{ item.createTime }} | {{ $t('homePage.hwcrm') }} | {{ item.applicantName }}</div>
            </div>
            <div class="info-column" v-if="workItemDetail.hwCrmNum > 50">
              <div class="workitem-link" @click="itemclickWorkItem(workItemDetail.hwCrmUrl, 'hwcrm')">
                待办数量共计{{ workItemDetail.hwCrmNum }}条，更多请进入海外CRM系统查看
              </div>
            </div>
            <div class="info-column" v-if="getFilteredList('auth-hwcrm').length === 0">{{ $t('mqzwdbcl') }}</div>
          </div>
        </TabPane>
        <TabPane :label="getTabLabel(todoList[4])" :name="'4'">
          <div class="backlog-list-wrapper">
            <div class="info-column" v-for="(item,index) in getFilteredList('auth-sap-pi')" :key="index">
              <div class="tips">
                <a :href="item.dealPath" target="_blank" @click="handleTimer">{{ item.subject }}</a>
              </div>
              <div class="time">{{ item.createTime }} | {{ $t('homePage.hr') }} | {{ item.applicantName }}</div>
            </div>
            <div class="info-column" v-if="workItemDetail.hrNum > 50">
              <div class="workitem-link" @click="itemclickWorkItem(workItemDetail.hrUrl, 'hr')">
                待办数量共计{{ workItemDetail.hrNum }}条，更多请进入HR系统查看
              </div>
            </div>
            <div class="info-column" v-if="getFilteredList('auth-sap-pi').length === 0">{{ $t('mqzwdbcl') }}</div>
          </div>
        </TabPane>
        <TabPane :label="getTabLabel(todoList[5])" :name="'5'">
          <div class="backlog-list-wrapper scrollbar">
            <div class="info-column" v-for="(item,index) in getFilteredList('auth-reim')" :key="index">
              <div class="tips">
                <a :href="item.dealPath" target="_blank" @click="handleTimer">{{ item.subject }}</a>
              </div>
              <div class="time">{{ item.createTime }} | {{ $t('homePage.fkxt') }} | {{ item.applicantName }}</div>
            </div>
            <div class="info-column" v-if="workItemDetail.reimNum > 50">
              <div class="workitem-link" @click="itemclickWorkItem(workItemDetail.reimUrl, 'reim')">
                待办数量共计{{ workItemDetail.reimNum }}条，更多请进入费控系统查看
              </div>
            </div>
            <div class="info-column" v-if="getFilteredList('auth-reim').length === 0">{{ $t('mqzwdbcl') }}</div>
          </div>
        </TabPane>
        <TabPane :label="getTabLabel(todoList[6])" :name="'6'">
          <div class="backlog-list-wrapper">
            <div class="info-column" v-for="(item,index) in getFilteredList('srm')" :key="index">
              <div class="tips">
                <a :href="item.dealPath" target="_blank" @click="handleTimer">{{ item.subject }}</a>
              </div>
              <div class="time">{{ item.createTime }} | {{ $t('homePage.srm') }} | {{ item.applicantName }}</div>
            </div>
            <div class="info-column" v-if="workItemDetail.srmNum > 50">
              <div class="workitem-link" @click="itemclickWorkItem(workItemDetail.srmUrl, 'srm')">
                待办数量共计{{ workItemDetail.srmNum }}条，更多请进入SRM系统查看
              </div>
            </div>
            <div class="info-column" v-if="getFilteredList('srm').length === 0">{{ $t('mqzwdbcl') }}</div>
          </div>
        </TabPane>
    </Tabs>
  </div>
</template>

<script>
import { cookie } from '@/libs/location'

export default {
  components: {},
  data () {
    return {
      // 当前选中的标签索引
      currentTabIndex: 0,
      // 标签页列表
      todoList: [
        {
          id: 1,
          name: this.$t('homePage.qb'),
          appsign: 'qb',
          isActive: true,
          number: 0
        },
        {
          id: 2,
          name: this.$t('homePage.oa'),
          appsign: 'auth-oa',
          isActive: false,
          number: 0
        },
        {
          id: 3,
          name: this.$t('homePage.crm'),
          appsign: 'auth-crm',
          isActive: false,
          number: 0
        },
        {
          id: 4,
          name: this.$t('homePage.hwcrm'),
          appsign: 'auth-hwcrm',
          isActive: false,
          number: 0
        },
        {
          id: 5,
          name: this.$t('homePage.hr'),
          appsign: 'auth-sap-pi',
          isActive: false,
          number: 0
        },
        {
          id: 6,
          name: this.$t('homePage.fkxt'),
          appsign: 'auth-reim',
          isActive: false,
          number: 0
        },
        {
          id: 7,
          name: this.$t('homePage.srm'),
          appsign: 'srm',
          isActive: false,
          number: 0
        }
      ],
      // 待办列表
      workItemList: [],
      // 待办详情
      workItemDetail: {
        crmNum: null,
        crmUrl: null,
        hrNum: null,
        hrUrl: null,
        oanum: null,
        oaurl: null,
        reimNum: null,
        reimUrl: null,
        hwCrmNum: null,
        hwCrmUrl: null,
        srmNum: null,
        srmUrl: null
      },
      // 定时器
      timer: null,
      timerTwo: null
    }
  },
  computed: {},
  created () {
    // 初始化待办列表
    this.doGetWorkItemList()
    // 设置轮询定时器，每5分钟刷新一次
    this.setTimer(300000)
  },
  beforeDestroy () {
    // 组件销毁前清除定时器
    if (this.timer) {
      clearInterval(this.timer)
    }
    if (this.timerTwo) {
      clearInterval(this.timerTwo)
    }
  },
  methods: {
    // 获取标签页标签文本
    getTabLabel (item) {
      if (!item) return ''
      const name = item.name === this.$t('homePage.qb') ? this.$t('homePage.qb') :
                   (item.name === this.$t('homePage.fkxt') ? this.$t('homePage.fkxt') :
                   (item.name === this.$t('homePage.oa') ? this.$t('homePage.oa') :
                   (item.name === this.$t('homePage.hr') ? this.$t('homePage.hr') :
                   (item.name === this.$t('homePage.crm') ? this.$t('homePage.crm') :
                   (item.name === this.$t('homePage.hwcrm') ? this.$t('homePage.hwcrm') :
                   (item.name === this.$t('homePage.srm') ? this.$t('homePage.srm') : item.name))))))
      return item.number > 0 ? `${name}(${item.number})` : name
    },
    // 标签页切换
    handleTabClick (name) {
      this.currentTabIndex = parseInt(name)
    },
    // 根据appSign过滤列表
    getFilteredList (appSign) {
      if (appSign === 'auth-sap-pi') {
        return this.workItemList.filter(k => ['auth-sap-pi', 'auth-sap-bw'].includes(k.appSign))
      }
      return this.workItemList.filter(k => k.appSign === appSign)
    },
    // 待办轮询
    setTimer (intMilliecond) {
      this.timer = setInterval(() => {
        this.doGetWorkItemList()
      }, intMilliecond)
    },
    // 处理定时器，检查是否需要重新加载
    handleTimer () {
      let that = this
      if (this.timerTwo === null) {
        this.timerTwo = setInterval(() => {
          that.$request.post('/sso/workItem/findIsNeedReload').then(res => {
            const { code, data } = res.data
            if (code === 'OK') {
              if (data) {
                clearInterval(that.timer)
                that.doGetWorkItemList()
                that.setTimer(300000)
                clearInterval(that.timerTwo)
                that.timerTwo = null
              }
            }
          })
        }, 4000)
      }
    },
    // 点击待办项跳转
    itemclickWorkItem (url, type) {
      if (type === 'oa' || type === 'hr' || type === 'reim') {
        window.open(url)
      } else {
        // CRM系统跳转需要特殊处理
        let _token = cookie.getCookie('token')
        this.$request.post('/sso/sync/loginOutInfo').then(res => {
          let { code } = res.data
          if (code === 'OK') {
            const appSign = type === 'crm' ? 'auth-crm' : (type === 'hwcrm' ? 'auth-hwcrm' : 'srm')
            window.open(`${this.$baseUrl}/sso/redirect/autoLogin?appSign=${appSign}&authorization=${_token}`, `sso${appSign}`)
          }
        })
      }
    },
    // 获取待办列表
    doGetWorkItemList () {
      this.$request.post('/sso/workItem/findList').then(res => {
        const { code, data } = res.data
        if (code === 'OK') {
          this.workItemDetail = {
            ...this.workItemDetail,
            ...data
          }
          // 更新各标签页的数量
          this.todoList.forEach(k => {
            k['number'] = 0
            switch (k.id - 1) {
              case 0:
                // 全部
                k.number = parseInt(data.crmNum || 0) + parseInt(data.hrNum || 0) + parseInt(data.oanum || 0) +
                           parseInt(data.reimNum || 0) + parseInt(data.hwCrmNum || 0) + parseInt(data.srmNum || 0)
                break
              case 1:
                // OA
                k.number = data.oanum || 0
                break
              case 2:
                // CRM
                k.number = data.crmNum || 0
                break
              case 3:
                // 海外CRM
                k.number = data.hwCrmNum || 0
                break
              case 4:
                // HR
                k.number = data.hrNum || 0
                break
              case 5:
                // 费控系统
                k.number = data.reimNum || 0
                break
              case 6:
                // SRM
                k.number = data.srmNum || 0
                break
              default:
                break
            }
          })
          // 更新待办列表
          this.workItemList = data.workItemList || []
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.backlog-card {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/deep/ .ivu-tabs {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}

/deep/ .ivu-tabs-bar {
  flex-shrink: 0;
}

/deep/ .ivu-tabs-content {
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
}

/deep/ .ivu-tabs-tabpane {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.info-column {
  margin-bottom: 8px;

  .tips {
    a {
      color: #333333;
      text-decoration: none;

      &:hover {
        color: var(--primary-color, #E5A135);
      }
    }
  }

  .workitem-link {
    font-size: 17px;
    line-height: 1.45;
    cursor: pointer;
    color: #0792FF;

    &:hover {
      text-decoration: underline;
    }
  }
}

.backlog-list-wrapper {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background: #ddd;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-track {
    background: #f5f5f5;
  }
}
</style>
